export const UploadIconGraySharp = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="20"
    viewBox="0 0 25 24"
    fill="none"
  >
    <g clipPath="url(#clip0_2604_1674)">
      <path
        d="M22.7028 9.84371C22.0466 9.35714 21.2403 8.99996 20.3891 8.8073C20.2493 8.77586 20.1213 8.7053 20.0202 8.60388C19.919 8.50245 19.8488 8.37433 19.8177 8.23449C19.452 6.60558 18.665 5.20871 17.5081 4.15027C16.1633 2.91792 14.3848 2.24011 12.5 2.24011C10.843 2.24011 9.3125 2.75949 8.07641 3.74246C7.23867 4.4097 6.56434 5.25942 6.10484 6.22683C6.05503 6.33268 5.98114 6.42541 5.88908 6.4976C5.79703 6.5698 5.68936 6.61946 5.57469 6.64261C4.32078 6.89574 3.18875 7.43339 2.32437 8.19511C1.13094 9.2498 0.5 10.6518 0.5 12.2526C0.5 13.8707 1.17922 15.3464 2.41203 16.4132C3.58953 17.43 5.17484 17.9901 6.875 17.9901H11.75V10.8009L10.0302 12.5207C9.95835 12.5925 9.87272 12.649 9.77845 12.6867C9.68418 12.7244 9.58323 12.7426 9.48172 12.7402C9.38021 12.7377 9.28026 12.7147 9.18792 12.6724C9.09558 12.6302 9.01278 12.5697 8.94453 12.4945C8.67266 12.1959 8.69891 11.7304 8.98438 11.445L11.9698 8.45996C12.1105 8.31941 12.3012 8.24046 12.5 8.24046C12.6988 8.24046 12.8895 8.31941 13.0302 8.45996L16.0156 11.444C16.31 11.7389 16.3269 12.2221 16.0339 12.5179C15.9644 12.5881 15.8817 12.6439 15.7906 12.6821C15.6995 12.7202 15.6017 12.74 15.5029 12.7402C15.4041 12.7405 15.3063 12.7212 15.215 12.6836C15.1236 12.6459 15.0407 12.5906 14.9708 12.5207L13.25 10.8009V17.9901H19.0625C20.5316 17.9901 21.8708 17.5776 22.8336 16.829C23.9239 15.9806 24.5 14.7665 24.5 13.3214C24.5 11.9179 23.8784 10.7146 22.7028 9.84371Z"
        fill="#a0a0a0"
      />
      <path
        d="M11.75 21.0098C11.75 21.2087 11.829 21.3995 11.9697 21.5401C12.1103 21.6808 12.3011 21.7598 12.5 21.7598C12.6989 21.7598 12.8897 21.6808 13.0303 21.5401C13.171 21.3995 13.25 21.2087 13.25 21.0098V17.9901H11.75V21.0098Z"
        fill="#a0a0a0"
      />
    </g>
    <defs>
      <clipPath id="clip0_2604_1674">
        <rect width="24" height="24" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);
